var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionContainer',{staticClass:"content"},[_c('h3',[_vm._v("Que tal adquirir o conhecimento para alcançar seus objetivos?")]),_c('StartNowButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }